export default __webpack_public_path__ + "static/media/cif-er.bbfc5171.svg";